<script>
  export let id;
  export let name;
  export let text;
  export let time;
  export let hasToken;
  export let xloc;
  export let yloc;
  const radius = 50;
  $: fill = getFillFromText(text);
  function getFillFromText(t) {
    if (t === "Running Non-CS Code") {
      return "#AAD8E6";
    }
    if (t === "Running Critical Section") {
      return "#D0F0C0";
    }
    if (t === "Waiting for CS Token") {
      return "#FBCEB1";
    }
  }
</script>

<g>
  <g {id}>
    <circle
      stroke="black"
      stroke-width="0px"
      {fill}
      cx={xloc}
      cy={yloc}
      r={radius} />
    <text
      font-weight="bold"
      x={xloc}
      y={yloc}
      dominant-baseline="central"
      text-anchor="middle"
      stroke-width="1px">
      {name}
    </text>
    {#if time}
      <text
        font-weight="bold"
        x={xloc}
        y={yloc - 25}
        dominant-baseline="central"
        text-anchor="middle"
        font-size="1.5em"
        stroke-width="2px">
        {time}
      </text>
    {/if}
  </g>
  {#if hasToken}
    <svg
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width="24"
      height="24"
      x={parseInt(xloc) + radius / 2}
      y={parseInt(yloc) + radius / 2}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M27.303,13.768l-0.909-0.545c-0.387-0.232-0.649-0.615-0.767-1.05c-0.002-0.008-0.004-0.016-0.007-0.024
        c-0.121-0.439-0.085-0.907,0.136-1.306l0.515-0.927c0.526-0.948-0.148-2.115-1.232-2.133l-1.07-0.018
        c-0.453-0.008-0.873-0.209-1.193-0.529c-0.003-0.003-0.007-0.007-0.01-0.01c-0.321-0.32-0.522-0.74-0.529-1.193l-0.018-1.07
        C22.2,3.877,21.033,3.203,20.085,3.73l-0.927,0.515c-0.398,0.221-0.866,0.257-1.306,0.136c-0.008-0.002-0.016-0.004-0.024-0.007
        c-0.435-0.119-0.818-0.38-1.05-0.767l-0.545-0.909c-0.558-0.93-1.905-0.93-2.463,0l-0.543,0.905c-0.234,0.39-0.62,0.653-1.058,0.773
        c-0.005,0.001-0.009,0.003-0.014,0.004c-0.443,0.122-0.914,0.086-1.316-0.137L9.915,3.73C8.967,3.203,7.8,3.877,7.782,4.961
        l-0.018,1.07C7.756,6.484,7.555,6.904,7.235,7.224c-0.003,0.003-0.007,0.007-0.01,0.01c-0.32,0.321-0.74,0.522-1.193,0.529
        l-1.07,0.018C3.877,7.8,3.203,8.967,3.73,9.915l0.515,0.927c0.221,0.399,0.257,0.866,0.136,1.306
        c-0.002,0.008-0.004,0.016-0.007,0.024c-0.119,0.435-0.38,0.818-0.767,1.05l-0.909,0.545c-0.93,0.558-0.93,1.906,0,2.463
        l0.909,0.546c0.387,0.232,0.649,0.615,0.767,1.05c0.002,0.008,0.004,0.016,0.007,0.024c0.121,0.44,0.085,0.907-0.136,1.306
        L3.73,20.085c-0.526,0.948,0.148,2.115,1.232,2.133l1.07,0.018c0.453,0.008,0.873,0.209,1.193,0.529
        c0.003,0.003,0.007,0.007,0.01,0.01c0.321,0.32,0.522,0.74,0.529,1.193l0.018,1.069c0.018,1.084,1.185,1.758,2.133,1.232
        l0.927-0.515c0.398-0.221,0.866-0.257,1.306-0.136c0.008,0.002,0.016,0.004,0.024,0.007c0.435,0.119,0.818,0.38,1.05,0.767
        l0.545,0.909c0.558,0.93,1.905,0.93,2.463,0l0.545-0.909c0.232-0.387,0.615-0.649,1.05-0.767c0.008-0.002,0.016-0.004,0.024-0.007
        c0.439-0.121,0.907-0.085,1.306,0.136l0.927,0.515c0.948,0.526,2.115-0.148,2.133-1.232l0.018-1.069
        c0.008-0.453,0.209-0.873,0.529-1.193c0.003-0.003,0.007-0.007,0.01-0.01c0.32-0.321,0.74-0.522,1.193-0.529l1.07-0.018
        c1.084-0.018,1.758-1.185,1.232-2.133l-0.515-0.927c-0.221-0.399-0.257-0.866-0.136-1.306c0.002-0.008,0.004-0.016,0.007-0.024
        c0.119-0.435,0.38-0.818,0.767-1.05l0.909-0.546C28.232,15.674,28.232,14.326,27.303,13.768z
        M20.707,12.707l-6.56,6.56
        c-0.188,0.188-0.442,0.293-0.707,0.293s-0.52-0.105-0.707-0.293l-3.453-3.453c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0
        l2.746,2.746l5.853-5.853c0.391-0.391,1.023-0.391,1.414,0S21.098,12.316,20.707,12.707z" />
    </svg>
  {/if}
  <text
    x={xloc}
    y={parseInt(yloc) + radius + 15}
    font-size="0.75em"
    stroke-width="1px"
    text-anchor="middle"
    dominant-baseline="central">
    {text}
  </text>
</g>
